import { render, staticRenderFns } from "./InboxLayout.vue?vue&type=template&id=0cb8516d&scoped=true&"
import script from "./InboxLayout.vue?vue&type=script&lang=js&"
export * from "./InboxLayout.vue?vue&type=script&lang=js&"
import style0 from "./InboxLayout.vue?vue&type=style&index=0&id=0cb8516d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb8516d",
  null
  
)

export default component.exports